import { makeStyles } from '../../../styles';
export const useStyles = makeStyles((theme) => ({
    button: {
        border: `1px solid ${theme.colors.gray[200]}`,
        padding: theme.spacing(0.5),
    },
    active: {
        color: theme.colors.primary.main,
        borderColor: theme.colors.primary.main,
        '& > svg': {
            color: theme.colors.primary.main,
        },
    },
    menuList: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        '& > li': {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
            borderRadius: 8,
            '&:hover': {
                backgroundColor: theme.colors.gray[100],
            },
        },
    },
    menuPaper: {
        marginTop: theme.spacing(0.5),
        boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.08)',
        borderRadius: 8,
    },
}));
//# sourceMappingURL=Menu.styles.js.map